import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../useTexts'

export function NotificationsListFailed() {
  const texts = useTexts()

  return (
    <Alert severity="error">
      <AlertTitle>{texts.notificationsListFailureTitle}</AlertTitle>
      {texts.notificationsListFailureDescription}
    </Alert>
  )
}
